import UI from 'fanplayr-ui'
import {
  ActionDataItem,
  FilterDef
} from '../types'
import {filters as filterMap} from '../data/filters.ts'
import store from '../store.ts'
import {translate} from '../i18n.ts'

export function formatActionDataItem(item: ActionDataItem): string {
  let text = translate('common.setXToY', { key: `"${item.key}"`, value: `"${item.value}"` })
  const options: string[] = []
  if (item.mode === 'setIfNotExists') {
    options.push(translate('common.if not already set'))
  }
  if (item.expireSeconds > 0) {
    const days = UI.format(item.expireSeconds * 1000, 'durationMs')
    options.push(translate('common.expireAfterDays', { days }))
  }
  return text + ' ' + options.join(` ${translate('common.and')} `)
}

const maxFilterDisplayValues = 2
interface FilterFormatPart {
  type: 'label' | 'operator' | 'value';
  value: string
}
export function formatFilterToParts(def: FilterDef): FilterFormatPart[] {
  const filter = filterMap[def.key]
  const parts: FilterFormatPart[] = [
    {
      type: 'label',
      value: filter.label
    }
  ]
  if ('operators' in filter) {
    const op = filter.operators.find(d => d.value === def.operator)
    const opLabel = op ? op.label : translate('common.[op]')
    parts.push({
      type: 'operator',
      value: opLabel.toLowerCase()
    })
  }
  if (filter.type === 'list') {
    if (def.value) {
      const options = Array.isArray(filter.options)
        ? filter.options
        : filter.options(store.state.account!)
      const values = def.value
        .split(',')
        .map(value => {
          const opt = options.find(d => d.value === value)
          return opt ? opt.label : `[${value}]`
        })
      let text = values
        .slice(0, maxFilterDisplayValues)
        .join(', ')
      const remaining = values.length - maxFilterDisplayValues
      if (remaining > 0) {
        text += ` ${translate('common.andXMore', { num: remaining })}`
      }
      parts.push({
        type: 'value',
        value: text
      })
    }
  } else {
    parts.push({
      type: 'value',
      value: def.value
    })
  }
  return parts
}
